import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../assets/styles/LoginPage.css';
import logo from './logo.png'; 
import apiService from "../../service/apiService";
import pagesData from "../../pages.json";

const LoginPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const fetchSidebar = async (roleId) => {
        console.log("pagesData in fetchSidebar:", pagesData);
        
        try {
            const response = await apiService.get(`/rbac/get-form-by-user-role/${roleId}`);
            const sidebarData = response.data.body || [];
    
            if (!sidebarData || sidebarData.length === 0) {
                console.warn("No sidebar data available; fallback to pagesData");
                return pagesData;
            }
    
            return sidebarData; 
        } catch (error) {
            console.error("Error fetching Sidebar:", error);
            console.warn("Fallback to pagesData due to error");
            return pagesData;  
        }
    };

    const getFirstPageUrl = (sidebarData) => {
        console.log("sidebarData in getFirstPageUrl:", sidebarData);
        if (sidebarData === pagesData) {
            console.log("sidebarData is identical to pagesData. Redirecting to first page URL.");
        
            const sortedPages = pagesData?.pages
                ? Object.values(pagesData.pages).sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
                : [];
        
            if (sortedPages.length > 0) {
                for (const mainPage of sortedPages) {
                    console.log("main page:", mainPage);
        
                    if (mainPage.innerPages) {
                        const sortedInnerPages = Object.values(mainPage.innerPages).sort(
                            (a, b) => (a.displayOrder || 0) - (b.displayOrder || 0)
                        );
        
                        if (sortedInnerPages.length > 0 && sortedInnerPages[0].url) {
                            console.log("Redirecting to the first innerPage URL:", sortedInnerPages[0].url);
                            return sortedInnerPages[0].url;
                        }
                    }
        
                    if (mainPage.url) {
                        console.log("Redirecting to main page URL (no innerPages):", mainPage.url);
                        return mainPage.url;
                    }
                }
            }
        
            console.warn("No valid URL found in pagesData");
            return null;
        }
        
    
        // **If sidebarData is not equal to pagesData, process the items**
        if (!sidebarData || !Array.isArray(sidebarData)) {
            console.warn("Invalid sidebarData provided to getFirstPageUrl");
            return null;
        }
    
        // Process each item in sidebarData
        for (const item of sidebarData) {
            console.log("Processing item:", item);
        
            // **If subForms are present, prioritize their URLs**
            if (item.subForms && Array.isArray(item.subForms)) {
                const sortedSubForms = item.subForms.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
                
                for (const subForm of sortedSubForms) {
                    console.log("Processing subForm:", subForm);
        
                    // Match formId from subForm with innerPages in pagesData
                    const mainPage = pagesData?.pages?.[String(item.formId)];
                    if (mainPage?.innerPages) {
                        const matchedInnerPage = mainPage.innerPages[String(subForm.formId)];
                        if (matchedInnerPage && matchedInnerPage.url) {
                            console.log("Redirecting to matched innerPage URL (from subForm):", matchedInnerPage.url);
                            return matchedInnerPage.url; // Redirect to the matched innerPage URL
                        }
                    }
        
                    // If subForm has a direct URL, use it as a fallback
                    if (subForm.url) {
                        console.log("Redirecting to the first inner page URL (subForm):", subForm.url);
                        return subForm.url;
                    }
                }
            }
        
            // **If no subForms, use the main page URL**
            if (item.url) {
                console.log("Redirecting to the main page URL (no subForms):", item.url);
                return item.url; // Return main page URL
            }
        
            // Match formId in main item with pagesData
            const matchedPage = pagesData?.pages?.[String(item.formId)];
            if (matchedPage && matchedPage.url) {
                console.log("Redirecting to matched formId URL in pagesData:", matchedPage.url);
                return matchedPage.url; // Return matched page URL
            }
        }
        
    
        console.warn("No valid URL found in sidebarData");
        return null; // If no valid URL found, return null
    };
            
    const handleSignUp = async (event) => {
        event.preventDefault(); 
        setError(''); 

        try {
            const response = await apiService.post('/users/web/login', {
                userId: email, 
                password: password,
            });

            if (response.data.status === 'success') {
                localStorage.setItem('token', response.data.token);
                const { blockId, districtId, user } = response.data;
                const blockCoordinatorsId = user.blockCoordinators[0]?.id || null;
                const districtCoordinatorsId = user.districtCoordinators[0]?.id || null;
                const userRoleId = user.userRoleId;
                const userId = user.userId;
                const userName = user.userName;
               
                localStorage.setItem(
                    "loginData",
                    JSON.stringify({
                      blockId,
                      districtId,
                      blockCoordinatorsId,
                      districtCoordinatorsId,
                      userRoleId,
                      userId,
                      userName
                    })
                  );
                
                // navigate('/dashboard', {
                //     state: {
                //       blockId,
                //       districtId,
                //       blockCoordinatorsId,
                //       districtCoordinatorsId,
                //       userRoleId,
                //       userId
                //     },
                //   });

            const sidebarData = await fetchSidebar(userRoleId);

            const firstPageUrl = getFirstPageUrl(sidebarData);
                if (firstPageUrl) {
                    navigate(firstPageUrl);
                } else {
                    setError('No pages available for this role.');
                }
            } else {
                setError(response.data.message || 'Login failed');
            }
        } catch (err) {
            setError('An error occurred during login. Please try again.');
        }
    };

    return (
        <div className="signup-container">
            <div className="left-section">
                <h1 className="offer-heading p-3">
                    Agriculture is sustainable
                    <br /> The farmer's life
                </h1>
                <p className="offer-text mt-5 p-3">
                    Sustainable agriculture is not just about growing crops, it's about caring for the soil, 
                    the water, the air, and all the living things that depend on them.
                </p>
            </div>
            <div className="right-section">
                <form className="signup-form" onSubmit={handleSignUp}>
                    <div className="LOGO">
                        <img src={logo} alt="Logo" className="logo" />
                    </div>
                    <div className="form-group">
                        <input 
                            type="email" 
                            placeholder="Email address" 
                            className="input-field" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <input 
                            type="password" 
                            placeholder="Password" 
                            className="input-field" 
                            value={password} 
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    <button type="submit" className="signup-button">Sign In</button>
                    <div className="social-signup">
                        <div className="social-icons">
                            {/* <i className="fab fa-facebook"></i>
                            <i className="fab fa-google"></i>
                            <i className="fab fa-twitter"></i>
                            <i className="fab fa-github"></i> */}
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
